export class BaoCaoChiTietDonHangBanModel {
    static optionsTinhTrang = [
        {
            id: 1,
            name: 'Chờ giao hàng',
            value: 'KDDHCT_CHOGIAOHANG',
            position: 1
        },
        {
            id: 2,
            name: 'Chưa giao đủ hàng',
            value: 'KDDHCT_CHUAGIAODUHANG',
            position: 2
        },
        {
            id: 3,
            name: 'Đã giao đủ hàng',
            value: 'KDDHCT_DAGIAODUHANG',
            position: 3
        },
        {
            id: 4,
            name: 'Chờ sản xuất',
            value: 'KDDHCT_CHOSANXUAT',
            position: 4
        },
        {
            id: 5,
            name: 'Đã sản xuất',
            value: 'KDDHCT_DASANXUAT',
            position: 4
        }
    ];
}

export class ThongTinTonKhoTheoBOM {
    KdDatHangCtId: number
    IdHH: number
    MaHang: string
    TenHang: string
    Dvt: number
    TenDVT: string
    TonKhoTuDo: number
    TonKhoPOKhac: number
    TonKhoPOChinh: number
    TypeHH: number    // 0 - Thành phẩm, 1 - Bán thành phẩm, 2 - NPL
    FlagHead: boolean;
    FlagBTP: boolean;
    isHighlight: boolean;
    clear() {
        this.KdDatHangCtId = 0;
        this.IdHH = 0;
        this.MaHang = "";
        this.TenHang = "";
        this.Dvt = 0;
        this.TenDVT = "";
        this.TonKhoTuDo = 0;
        this.TonKhoPOKhac = 0;
        this.TonKhoPOChinh = 0;
        this.TypeHH = -1;
        this.FlagHead = false;
        this.FlagBTP = false;
        this.isHighlight = false;
    }
    copy(item: ThongTinTonKhoTheoBOM) {
        this.KdDatHangCtId = item.KdDatHangCtId;
        this.IdHH = item.IdHH;
        this.MaHang = item.MaHang;
        this.TenHang = item.TenHang;
        this.Dvt = item.Dvt;
        this.TenDVT = item.TenDVT;
        this.TonKhoTuDo = item.TonKhoTuDo;
        this.TonKhoPOKhac = item.TonKhoPOKhac;
        this.TonKhoPOChinh = item.TonKhoPOChinh;
        this.TypeHH = item.TypeHH;
        this.FlagHead = item.FlagHead;
        this.FlagBTP = item.FlagBTP;
    }
}

export class ConstantBCCTDH {
    public static PARAM_TDCTDH_B2B = "po-b2b-theo-doi-chi-tiet-don-hang-ban";
    public static PARAM_TDCTDH_B2C = "po-b2c-theo-doi-chi-tiet-don-hang-ban";
    public static readonly CODE_B2B = "B2B";
    public static readonly CODE_B2C = "B2C";
}